<ng-container>
  <wc-grid #globalGrid gridKey="globalUsers" [reloadUserOnSave]="true"
           [showQuickSearch]="true" searchPlaceholder="Search users..." />
</ng-container>
